// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-drawer__header[data-v-1964ad53] {\n  margin-bottom: 10px !important;\n}\n", ""]);
// Exports
module.exports = exports;
